"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7 11a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 7 11"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17 16.292a8 8 0 1 0-.707.707l4.853 4.855a.5.5 0 0 0 .708-.708zM11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
  })]
}), 'ZoomOut');
